import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "./Logo";

const NAV = [
  { label: "Fitur", href: "#fitur" },
  { label: "Cara Kerja", href: "#cara-kerja" },
  { label: "Harga", href: "#harga" },
  { label: "Testimoni", href: "#testimoni" },
  { label: "FAQ", href: "#faq" },
];

export const Header = ({ onTrial, onLogin }) => {
  const [open, setOpen] = useState(false);

  const scrollTo = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className="fixed top-0 z-50 w-full glass border-b border-cyan-500/10"
      data-testid="site-header"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3.5 lg:px-8">
        <button onClick={() => scrollTo("#hero")} data-testid="header-logo-btn">
          <Logo />
        </button>

        <nav className="hidden items-center gap-8 lg:flex">
          {NAV.map((item) => (
            <button
              key={item.href}
              onClick={() => scrollTo(item.href)}
              data-testid={`nav-${item.href.slice(1)}`}
              className="text-sm font-medium text-slate-300 transition-colors hover:text-cyan-400"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <Button
            variant="ghost"
            onClick={onLogin}
            data-testid="header-login-btn"
            className="text-slate-200 hover:bg-cyan-500/10 hover:text-cyan-400"
          >
            Login Sekolah
          </Button>
          <Button
            onClick={onTrial}
            data-testid="header-trial-btn"
            className="bg-gradient-to-r from-cyan-400 to-violet-600 font-semibold text-[#060A12] transition-all hover:opacity-90 hover:shadow-[0_0_20px_rgba(0,240,255,0.4)]"
          >
            Coba Gratis 14 Hari
          </Button>
        </div>

        <button
          className="text-slate-200 lg:hidden"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="overflow-hidden border-t border-cyan-500/10 glass lg:hidden"
            data-testid="mobile-menu"
          >
            <div className="flex flex-col gap-1 px-5 py-4">
              {NAV.map((item) => (
                <button
                  key={item.href}
                  onClick={() => scrollTo(item.href)}
                  className="rounded-lg px-3 py-2.5 text-left text-sm font-medium text-slate-300 hover:bg-cyan-500/10 hover:text-cyan-400"
                >
                  {item.label}
                </button>
              ))}
              <div className="mt-3 flex flex-col gap-2">
                <Button variant="outline" onClick={() => { setOpen(false); onLogin(); }} data-testid="mobile-login-btn" className="border-cyan-500/30 text-slate-100">
                  Login Sekolah
                </Button>
                <Button onClick={() => { setOpen(false); onTrial(); }} data-testid="mobile-trial-btn" className="bg-gradient-to-r from-cyan-400 to-violet-600 font-semibold text-[#060A12]">
                  Coba Gratis 14 Hari
                </Button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
